import { render, staticRenderFns } from "./incomeLossFromHousingProperty.vue?vue&type=template&id=0f4b8300&scoped=true"
import script from "./incomeLossFromHousingProperty.vue?vue&type=script&lang=js"
export * from "./incomeLossFromHousingProperty.vue?vue&type=script&lang=js"
import style0 from "./incomeLossFromHousingProperty.vue?vue&type=style&index=0&id=0f4b8300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b8300",
  null
  
)

export default component.exports